import { render, staticRenderFns } from "./add-relevant-obj.vue?vue&type=template&id=22ed459e&scoped=true&"
import script from "./add-relevant-obj.vue?vue&type=script&lang=js&"
export * from "./add-relevant-obj.vue?vue&type=script&lang=js&"
import style0 from "./add-relevant-obj.vue?vue&type=style&index=0&id=22ed459e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed459e",
  null
  
)

export default component.exports